//Angular
import {ChangeDetectorRef, Component, Inject, OnInit} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {
    AbstractControl,
    FormArray,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource} from "@angular/material";
import { Router} from "@angular/router";
//Models
import {Product} from "../../../../persistence/circular-dto/product.conflict";

//Services
import {InventoryService} from "../../../../service/club-gigot/inventory.service";
import {
    SaveInventoryGigotProductDto
} from "../../../../model/club-gigot/inventory-points/product/save-inventory-gigot-product.dto";
import {
    SaveGigotProductResultModel
} from "../../../../model/club-gigot/inventory-points/product/save-gigot-product-result.model";
import {QueryParamsModel, QueryResultsModel} from "../../../../core/_base/crud";
import {InventoryProductDTO} from "../../../../model/club-gigot/inventory-points/product/inventory-product.dto";


@Component({
  selector: 'cg-dialog-add-new-catalog-product',
  templateUrl: './dialog-add-new-catalog-product.component.html',
  styleUrls: ['./dialog-add-new-catalog-product.component.scss']
})
export class DialogAddNewCatalogProductComponent implements OnInit {

    public loadingData$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public productsForm : FormGroup;
    public displayedColumns = ['product', 'stock', 'actions'];
    public tableDataSource: MatTableDataSource<any>;
    private products$ = new BehaviorSubject<InventoryProductDTO[]>([]);

    constructor( private dialogRef: MatDialogRef<DialogAddNewCatalogProductComponent>,
                 private inventoryService: InventoryService,
                 @Inject(MAT_DIALOG_DATA)
                 public data: DialogData,
    ) { }

    ngOnInit() {
        this.loadingData$.next(true)
        this.inventoryService.getProducts(new QueryParamsModel({"Name": ""}, 'asc', 'id', 1, 999))
            .subscribe({
                next : (products) => {
                    this.products$.next(products.items);
                    if(products.totalCount > 999){
                        this.getProducts(products.totalCount)
                    }

                    this.buildForm();
                    this.tableDataSource = new MatTableDataSource(this.getFormArray().controls);
                    this.loadingData$.next(false)
                }
            })


    }

    private getProducts(size: number) : void {
        this.inventoryService.getProducts(new QueryParamsModel({"Name": ""}, 'asc', 'id', 1, size))
            .subscribe({
                next: (data: QueryResultsModel) => {
                    if(data.totalCount > size)
                        this.getProducts(data.totalCount)
                    else
                        this.products$.next(data.items);
                },
                error: (err: Error) => {
                    console.log(err);
                }
            })
    }

    private setProductForm(): FormGroup[] {
        let form: FormGroup[] = [];
        for(let product of this.data.selected){
            let formGroup = new FormGroup(
                {
                    product: new FormControl(product),
                    stock: new FormControl(null, [Validators.required, Validators.min(1)])
                }
            )
            formGroup.controls['product'].setValidators([this.validateCode()])
            form.push(formGroup)
        }
        return form;
    }

    private buildForm(){
        this.productsForm = new FormGroup({
            products: new FormArray(this.setProductForm())
        })
    }

    public getFormArray(): FormArray{
        return this.productsForm.controls['products'] as FormArray;
    }

    //Acciones
    public onCreate(): void{
        this.loading$.next(true);
        let products: SaveInventoryGigotProductDto[] = [];
        for(let data of this.getFormArray().controls){
            let product: SaveInventoryGigotProductDto = new SaveInventoryGigotProductDto();
            product.stock = data.value.stock;
            product.name = data.value.product.name;
            product.imageUrl = data.value.product.imagePath;
            product.code = data.value.product.code;
            product.voucher = false;
            product.inPiqueo = true;
            product.isGigotProduct = true;
            products.push(product)
        }
        this.inventoryService.createGigotProduct(products).subscribe(
            {
                next: _ => {
                    this.dialogRef.close(new SaveGigotProductResultModel(false, true));
                },
                error: (err: Error)=>{
                    this.dialogRef.close(new SaveGigotProductResultModel(false, false, err.message))
                }
            }
        )
    }

    public deleteProduct(index: number): void{
        this.getFormArray().removeAt(index);
        this.tableDataSource =new MatTableDataSource(this.getFormArray().controls);
    }

    public onNoClick(): void {
        this.dialogRef.close(new SaveGigotProductResultModel(true));
    }

    /**
     * @description
     *	Valida que el producto selecionado no este ya dentro del inventario
     */
    private validateCode(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (this.products$.value.find(p => p.code == control.value.code) != undefined)
                return {existingCode: true}
            return null
        };
    }
}

export interface DialogData {
    selected: Product[];
}

